<template>
    <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
            <div class="md-layout">
                <div class="md-layout-item">
                    <div class="card-icon">
                        <font-awesome-icon class="md-icon" :icon="['fa', 'phone']" />
                    </div>
                    <h4 class="title">Autres demandes liées</h4>
                </div>
            </div>
        </md-card-header>
        <md-card-content>
            <template v-if="demand.client === null && demand.prospect === ''">
                <p>Veuillez choisir un client ou ajouter un nom de prospect</p>
            </template>
            <template v-else>
                <template v-if="linkedDemands.length > 0">
                    <div v-for="linkedDemand in linkedDemands" :key="linkedDemand.id" class="text-sm mb-2.5">
                        <div>
                            {{ $moment(linkedDemand.date).format('DD/MM/YYYY') + ' - ' }}
                            <span v-if="linkedDemand.client">{{ linkedDemand.client.name }}</span>
                            <span v-else-if="demand.client">{{ demand.client.name }}</span>
                            <span v-else>{{ linkedDemand.prospect }}</span>
                            <span v-if="linkedDemand.site">{{ ' (' + linkedDemand.site.name + ')' }}</span>
                            <span v-else-if="demand.site">{{ ' (' + demand.site.name + ')' }}</span>
                        </div>
                        <div class="flex items-start">
                            <div class="mr-2">
                                <md-button class="md-icon-button md-small-icon md-rounded-icon my-0 md-default cursor-default">
                                    <font-awesome-icon class="md-icon" :icon="['fa', 'info']" />
                                </md-button>
                                <md-tooltip md-direction="top">
                                    <div>
                                        <b>Message : </b>
                                        {{ linkedDemand.message }}
                                    </div>
                                </md-tooltip>
                            </div>
                            <div>
                                <span class="text-info cursor-pointer"
                                      @mousedown="goToRoute($event,'Demand Details', { demandId: linkedDemand.id })">
                                    {{ linkedDemand.subject }}
                                </span>
                                <p class="mb-0">({{ statusDemand(linkedDemand.status) }})</p>
                            </div>
                        </div>
                    </div>
                </template>
                <p v-else>Aucune demande liée.</p>
            </template>
        </md-card-content>
    </md-card>
</template>

<script>
import routerMixin from '@/mixins/router-mixin';

export default {
    name: "DemandLinked",
	mixins: [routerMixin],
    props: {
        demand: Object,
        linkedDemands: Array
    },
    methods: {
        statusDemand(status) {
            return status === 0 ? 'Non traitée' : (status === 1 ? 'Traitée' : 'En attente')
        },
    }
}
</script>

<style scoped>

</style>
